import omitProps from '@hocs/omit-props';
import { compose, setDisplayName, withProps } from 'recompose';
import { ExperimentSpec } from '../../../constants/ExperimentSpec';
import { withExperiments } from '../withExperiments';

export const withExperimentsSettings = compose(
  setDisplayName('withExperimentsSettings'),
  withExperiments,
  withProps(({ experiments }) => ({
    _experimentsSettings: {
      isEmailWithWixDomain: experiments.enabled(ExperimentSpec.PublicMediaWixOnly),
      isCantBuyOnShutterstockExperimentEnabled: experiments.enabled(ExperimentSpec.CantBuyOnShutterstock),
      isNewCheckoutExperimentEnabled: experiments.enabled(ExperimentSpec.NewCheckout),
      isPublicMediaScoringProfileEnabled: experiments.enabled(ExperimentSpec.PublicMediaScoringProfile),
      isNTTExperimentEnabled: experiments.enabled(ExperimentSpec.NTT),
      isShowKeysExperimentEnabled: experiments.enabled(ExperimentSpec.ShowKeys),
      isOnlyFavsBoardExperimentEnabled: experiments.enabled(ExperimentSpec.OnlyFavsBoard),
      isPreventFontsUploadExperimentEnabled: experiments.enabled(ExperimentSpec.PreventFontsUpload),
      forceUploadErrorsExperimentValue: experiments.get(ExperimentSpec.ForceUploadErrors),
      isDisableUploadExperimentEnabled: experiments.enabled(ExperimentSpec.DisableUpload),
      isLinkToPublicCMSExperimentEnabled: experiments.enabled(ExperimentSpec.LinkToPublicCMS),
      isYellExperimentEnabled: experiments.enabled(ExperimentSpec.Yell),
      isForceYellExperimentEnabled: experiments.enabled(ExperimentSpec.ForceYell),
      isAITextToImageEnabled: experiments.enabled(ExperimentSpec.AiTextToImage),
      storageQuotaVisibilityAndEnforcementExperiment: experiments.get(
        ExperimentSpec.StorageQuotaVisibilityAndEnforcement,
      ),
      storageQuotaGracePeriodExperimentEnabled: experiments.enabled(ExperimentSpec.StorageQuotaGracePeriod),
      isManageStorageButtonEnabled: experiments.enabled(ExperimentSpec.ManageStorageButton),
      isUIAlignmentsEnabled: experiments.enabled(ExperimentSpec.UIAlignments),
      isLimitMimeTypesEnabled: experiments.enabled(ExperimentSpec.LimitMimeTypes),
      isFileAwarenessEnabled: experiments.enabled(ExperimentSpec.FileAwareness),
      isPlatformizationTypesCheckEnabled: experiments.enabled(ExperimentSpec.PlatformizationTypesCheck),
      isPlatformizedApiEnabled: experiments.enabled(ExperimentSpec.UsePlatformizedApi),
      isHideInstagramEnabled: experiments.enabled(ExperimentSpec.HideInstagram),
      isHideFlickrEnabled: experiments.enabled(ExperimentSpec.HideFlickr),
      isHideGooglePhotosEnabled: experiments.enabled(ExperimentSpec.HideGooglePhotos),
      isUseSmallerLimitForPublicSearchEnabled: experiments.enabled(ExperimentSpec.UseSmallerLimitForPublicSearch),
      isIgnoreEmptyRouteEnabled: experiments.enabled(ExperimentSpec.IgnoreEmptyRoute),
      isHideAdobeExpressEnabled: experiments.enabled(ExperimentSpec.HideAdobeExpress),
      isWixSession3Enabled: experiments.enabled(ExperimentSpec.WixSession3),
      isCopyWixUrlEnabled: experiments.enabled(ExperimentSpec.CopyWixUrl),
    },
  })),
);

export const withoutExperimentsSettings = omitProps('_experimentsSettings');
